module.exports = __webpack_public_path__ + "img/DE02644.09fe7d70.png";